export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: 'Certification in Full Stack Web Development',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Devi Ahilya Vishwavidyalaya',
        course: 'Bachelor of Computer Application',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'SGRJPS',
        course: 'Higher Secondary Education',
        startYear: '2017',
        endYear: '2018'
    },
]